import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaHome, FaBars, FaTimes, FaSlidersH } from 'react-icons/fa';
import './MobileMenu.css';

function MobileMenu() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  // Handle body scroll lock when menu is open
  useEffect(() => {
    if (isMenuOpen) {
      document.body.classList.add('MNU-menu-open');
    } else {
      document.body.classList.remove('MNU-menu-open');
    }

    // Cleanup on unmount
    return () => {
      document.body.classList.remove('MNU-menu-open');
    };
  }, [isMenuOpen]);

  // Navigation links - same as in Navmenu
  const links = [
    { id: 1, title: 'navigation.home', href: '/home', icon: <FaHome className="MNU-nav-icon" /> },
    { id: 2, title: 'navigation.about', href: '/About', icon: null },
    { id: 3, title: 'navigation.contact', href: '/Contact', icon: null },
  ];

  return (
    <div className="MNU-mobile-menu">
      {/* Hamburger Menu Button */}
      <button 
        className="MNU-hamburger-button"
        onClick={toggleMenu}
        aria-label="Toggle navigation menu"
      >
        {isMenuOpen ? <FaTimes /> : <FaBars />}
      </button>

      {/* Overlay */}
      {isMenuOpen && (
        <div 
          className="MNU-overlay"
          onClick={closeMenu}
        ></div>
      )}

      {/* Menu Content */}
      <div className={`MNU-menu-content ${isMenuOpen ? 'MNU-menu-open' : ''}`}>
        <div className="MNU-menu-header">
          <h3 className="MNU-menu-title">{t('navigation.menu', 'Menu')}</h3>
          <button 
            className="MNU-close-button"
            onClick={closeMenu}
            aria-label="Close menu"
          >
            <FaTimes />
          </button>
        </div>

        <nav className="MNU-nav-links">
          {links.map((link) => (
            <Link
              key={link.id}
              to={link.href}
              className="MNU-nav-link"
              onClick={closeMenu}
            >
              {link.icon}
              <span className="MNU-nav-text">{t(link.title)}</span>
            </Link>
          ))}
          
          {/* Settings button - added for mobile */}
          <button
            className="MNU-nav-link MNU-settings-link"
            onClick={() => {
              navigate('/settings');
              closeMenu();
            }}
          >
            <FaSlidersH className="MNU-nav-icon" />
            <span className="MNU-nav-text">{t('menu.settings', 'Settings')}</span>
          </button>
        </nav>
      </div>
    </div>
  );
}

export default MobileMenu;
